import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';

import { getCategory } from '../../store/category-page.selectors';

import { Category } from '@core/domain/models/category.models';
import { SeoInfo } from '@core/domain/models/seo.models';
import { getMenuCategory } from '@pages/category/public_api';
import { AttachmentsEnums } from '@shared/header/services/attachments.enums';

@Injectable()

/**
 * Servicio para interactuar con el SEO de las categorias de parrillas
 */
export class CategorySeoService {
    constructor(
        private readonly store: Store,
        private readonly translateService: TranslateService,
    ) { }

    /**
     * Función para obtener categorías relacionadas en base a categoría padre y attachments GAUDÍ
     */
    public getRelatedCategories(): Observable<Category[]> {
        return this.store.select(getMenuCategory).pipe(
            filter(categories => !!categories?.subCategories),
            map((categories: any) => {
                return categories.subCategories?.filter((category) => {
                    return category?.attachments?.find((attachment: any) => attachment.name === AttachmentsEnums.GAUDI)
                        && categories.currentCategory.id !== category.id;
                });
            })
        );
    }

    /**
     * Función para obtener los datos de SEO para categorias que contienen filtros en la Url
     */
    public getseoInfoForFilteredCategories(seoInfo: SeoInfo, params: Params): Observable<SeoInfo> {
        return this.store.select(getCategory).pipe(

            startWith(null),
            filter((category: Category) => !!category),
            // Obtenemos las traducciones desde CMS
            switchMap((category: Category) => forkJoin({
                longDescription: this.translateService.get(`dev.categories.grid.seo.${category.id}.${params.g}.longDescription`),
                secondaryTitle: this.translateService.get(`dev.categories.grid.seo.${category.id}.${params.g}.secondaryTitle`),
            })
                // Comprobamos que existan las traducciones
                .pipe(map((translations: any) => {
                    if (
                        translations.longDescription === `dev.categories.grid.seo.${category.id}.${params.g}.longDescription`
                        || translations.secondaryTitle === `dev.categories.grid.seo.${category.id}.${params.g}.secondaryTitle`
                    ) {
                        return null;
                    }

                    return translations;
                }))),
            // Retornamos la información de SEO con los nuevos textos
            map((translations: any) => {
                if (translations) {
                    const seoInfoGaudi = JSON.parse(JSON.stringify(seoInfo));

                    seoInfoGaudi.longDescription = translations.longDescription;
                    seoInfoGaudi.secondaryTitle = translations.secondaryTitle;

                    return seoInfoGaudi;
                }

                return null;
            })
        );
    }
}
